import "core-js/modules/es.array.concat";
import "core-js/modules/es.object.keys";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import apis from '@/apis/home';
import EmptyContent from '@/views/Layout/EmptyContent.vue';
import LoadEmpty from '@/views/Layout/LoadEmpty.vue';
import Calendar from '@/components/Calendar/index.vue';
import { pageForDate } from '@/components/Calendar/utils/utils';
import SchedulingCaseCard from './SchedulingCaseCard.vue';
import TodayCard from './TodayCard.vue';
import NoScheduleCard from './NoScheduleCard.vue';
import CaseNumberChart from './CaseNumberChart.vue';
var pageTimeout;
var caseTimeout;

var Home = /*#__PURE__*/function (_Vue) {
  _inherits(Home, _Vue);

  var _super = _createSuper(Home);

  function Home() {
    var _this;

    _classCallCheck(this, Home);

    _this = _super.call(this);
    _this.currentPage = 1;
    _this.monthCaseNumber = [];
    _this.yearCaseNumber = [];
    _this.monthData = [];
    _this.yearData = [];
    _this.monthCaseType = [];
    _this.yearCaseType = [];
    _this.todayLoading = true;
    _this.todaySchduleList = [];
    _this.noScheduleCaseList = [];
    _this.noScheduleCaseTotal = 0;
    _this.statistic = {
      trialNum: 0,
      trialHourCount: '0',
      trialHourAvg: '0'
    };
    _this.index = '0';
    _this.schedulingCaseLoading = false;
    _this.activeDate = new Date();
    _this.page = pageForDate(_this.activeDate);
    _this.highlightDays = [];
    _this.schedulingCaseList = [];
    return _this;
  }

  _createClass(Home, [{
    key: "handleDateChange",
    value: function () {
      var _handleDateChange = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.getCaseList();

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleDateChange() {
        return _handleDateChange.apply(this, arguments);
      }

      return handleDateChange;
    }() // 获取今日排期

  }, {
    key: "getTodaySchdule",
    value: function getTodaySchdule() {
      var _this2 = this;

      apis.todaySchedules({
        pageNo: 1,
        pageSize: 100
      }).then(function (res) {
        _this2.todaySchduleList = res.data.list || []; // (this.$refs.elCarousel as any).setActiveItem(0)

        _this2.todayLoading = false;
      }).catch(function (_) {
        _this2.todayLoading = false;
      });
    } // 获取未排期的案件

  }, {
    key: "getNoScheduleCase",
    value: function getNoScheduleCase(pageNo) {
      var _this3 = this;

      apis.unPlanCase({
        pageNo: pageNo,
        pageSize: 3
      }).then(function (res) {
        _this3.noScheduleCaseList = res.data.list || [];
        _this3.noScheduleCaseTotal = res.data.total;
      }).catch(function (_) {});
    } // 获取排期列表

  }, {
    key: "getCaseList",
    value: function getCaseList() {
      var _this4 = this;

      clearTimeout(caseTimeout);
      this.schedulingCaseLoading = true;
      caseTimeout = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this4.fetchCaseList(_this4.activeDate, _this4.index);

              case 2:
                _this4.schedulingCaseList = _context2.sent;
                _this4.schedulingCaseLoading = false;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })), 500);
    }
  }, {
    key: "handleIndexChange",
    value: function () {
      var _handleIndexChange = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(index) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.index = index;
                this.handleDateChange();
                _context3.next = 4;
                return this.fetchHighlightDays(this.page, index);

              case 4:
                this.highlightDays = _context3.sent;

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleIndexChange(_x) {
        return _handleIndexChange.apply(this, arguments);
      }

      return handleIndexChange;
    }()
  }, {
    key: "handlePageChange",
    value: function handlePageChange(page) {
      var _this5 = this;

      clearTimeout(pageTimeout);
      this.page = page;
      pageTimeout = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this5.fetchHighlightDays(page, _this5.index);

              case 2:
                _this5.highlightDays = _context4.sent;

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      })), 500);
    } // 请求排期

  }, {
    key: "fetchHighlightDays",
    value: function fetchHighlightDays(page, index) {
      var tabToApiMap = [apis.myScheduleWithDate, apis.myCreateScheduleWithDate];
      var month = "".concat(page.year, "-").concat(page.month);
      var lastDay = new Date(page.year, page.month, 0).getDate();
      var options = {
        searchDateStart: "".concat(month, "-", 1),
        searchDateEnd: "".concat(month, "-").concat(lastDay)
      };
      return tabToApiMap[index](options).then(function (res) {
        return Object.keys(res.data);
      }).catch(function (_) {
        return [];
      });
    } // 请求某日事件列表

  }, {
    key: "fetchCaseList",
    value: function fetchCaseList(date, index) {
      var tabToApiMap = [apis.mySchedule, apis.myCreateSchedule];
      var rDate = date instanceof Date ? "".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate()) : date;
      var options = {
        searchDateStart: rDate,
        searchDateEnd: rDate
      };
      return tabToApiMap[index](options).then(function (res) {
        return res.data || [];
      }).catch(function (_) {
        return [];
      });
    } // 删除已排期案件成功回调

  }, {
    key: "onDeleteCasePlanSuccess",
    value: function onDeleteCasePlanSuccess() {
      this.getTodaySchdule();
      this.getCaseList();
    } // 取消排期

  }, {
    key: "onCancelScheduleSuccess",
    value: function onCancelScheduleSuccess() {
      this.getTodaySchdule();
      this.getCaseList();
      this.currentPage = 1;
      this.getNoScheduleCase(1);
    } // 重新排期

  }, {
    key: "onAgainSchedule",
    value: function onAgainSchedule() {
      this.getTodaySchdule();
      this.getCaseList();
    } // 获取统计数据

  }, {
    key: "getStatistic",
    value: function getStatistic() {
      var _this6 = this;

      apis.statistic({
        timeType: 'all',
        userId: this.userId
      }).then(function (res) {
        _this6.statistic = res.data;
      }).catch(function (_) {});
    }
  }, {
    key: "onCreateCase",
    value: function onCreateCase() {
      this.$router.push({
        name: 'CaseCreate'
      });
    }
  }, {
    key: "noScheduleChange",
    value: function noScheduleChange(val) {
      this.getNoScheduleCase(val);
    } // 获取月统计数据

  }, {
    key: "getChartMonthData",
    value: function getChartMonthData() {
      var _this7 = this;

      apis.statisticWithMonth().then(function (res) {
        _this7.monthData = res.data.monthData || [];

        for (var i = 0; i < _this7.monthData.length; i++) {
          _this7.monthCaseType.push(_this7.monthData[i].weekIndex + 1);

          _this7.monthCaseNumber.push(_this7.monthData[i].statisticData);
        }
      }).catch(function (_) {});
    } // 获取年统计数据

  }, {
    key: "getChartYearData",
    value: function getChartYearData() {
      var _this8 = this;

      apis.statisticWithYear().then(function (res) {
        _this8.yearData = res.data.yearData || [];

        for (var i = 0; i < _this8.yearData.length; i++) {
          _this8.yearCaseType.push(_this8.yearData[i].monthIndex + 1);

          _this8.yearCaseNumber.push(_this8.yearData[i].statisticData);
        }
      }).catch(function (_) {});
    }
  }, {
    key: "created",
    value: function created() {
      this.getTodaySchdule();
      this.getNoScheduleCase(1);
      this.getChartMonthData();
      this.getChartYearData();
      this.getStatistic();
      this.handleIndexChange(this.index);
    }
  }, {
    key: "userName",
    get: function get() {
      return this.$store.getters.userInfo.userName || '';
    }
  }, {
    key: "userId",
    get: function get() {
      return this.$store.getters.userInfo.userId || '';
    }
  }, {
    key: "arrow",
    get: function get() {
      if (this.schedulingCaseList.length > 1) {
        return 'always';
      }

      return 'never';
    }
  }]);

  return Home;
}(Vue);

__decorate([Watch('activeDate')], Home.prototype, "handleDateChange", null);

Home = __decorate([Component({
  components: {
    TodayCard: TodayCard,
    NoScheduleCard: NoScheduleCard,
    CaseNumberChart: CaseNumberChart,
    EmptyContent: EmptyContent,
    LoadEmpty: LoadEmpty,
    SchedulingCaseCard: SchedulingCaseCard,
    Calendar: Calendar
  }
})], Home);
export default Home;